let routes = [{
  path: "/",
  redirect: "/index"
},
{
  path: '/index',
  name: 'index',
  component: () => import('@/views/page/home') // 首页
},
{
  path: '/login',
  name: 'login',
  component: () => import('@/views/page/login/login') //
},
{
  path: '/register',
  name: 'register',
  component: () => import('@/views/page/login/register') //
},
{
  path: '/reset',
  name: 'reset',
  component: () => import('@/views/page/login/reset') //
},
{
  path: '/navpolicy',
  name: 'navpolicy',
  component: () => import('@/views/page/policy') //
},
{
  path: '/navPolicyDetail',
  name: 'navPolicyDetail',
  component: () => import('@/views/page/policy/detail') //
},
{
  path: '/navNotice',
  name: 'navNotice',
  component: () => import('@/views/page/notice') //
},
{
  path: '/navNoticeDetail',
  name: 'navNoticeDetail',
  component: () => import('@/views/page/notice/detail') //
},
{
  path: '/navpg',
  name: 'navpg',
  component: () => import('@/views/page/pg') //
},
{
  path: '/navnu',
  name: 'navnu',
  component: () => import('@/views/page/un') //
},
{
  path: '/navcorp',
  name: 'navcorp',
	component: () => import('@/views/page/corpinfo') 
},
{
  path: '/navcorpdetail',
  name: 'navcorpdetail',
  component: () => import('@/views/page/corpinfo/detail.vue') //
},
{
  path: '/navneed',
  name: 'navneed',
  component: () => import('@/views/page/need')
},
{
  path: '/navneeddetail',
  name: 'navneeddetail',
  component: () => import('@/views/page/need/detail.vue') //
},
{
  path: '/navunneed',
  name: 'navunneed',
  component: () => import('@/views/page/unneed')
},
{
  path: '/navunneeddetail',
  name: 'navunneeddetail',
  component: () => import('@/views/page/unneed/detail.vue') //
},
{
  path: '/navneednotice',
  name: 'navneednotice',
  component: () => import('@/views/page/neednotice') //
},
{
  path: '/navabout',
  name: 'navabout',
  component: () => import('@/views/page/about') //
},
{
  path: '/navtag0',
  name: 'navtag0',
  component: () => import('@/views/page/moudel/tag0') //
},
{
  path: '/navtag1',
  name: 'navtag1',
  component: () => import('@/views/page/moudel/tag1') //
},
{
  path: '/navtag2',
  name: 'navtag2',
  component: () => import('@/views/page/moudel/tag2') //
},
{
  path: '/navtag3',
  name: 'navtag3',
  component: () => import('@/views/page/moudel/tag3') //
},
{
  path: '/navtag4',
  name: 'navtag4',
  component: () => import('@/views/page/moudel/tag4') //
},
{
  path: '/navtag5',
  name: 'navtag5',
  component: () => import('@/views/page/moudel/tag5') //
},
{
  path: '/navtag6',
  name: 'navtag6',
  component: () => import('@/views/page/moudel/tag6') //
},
{
  path: '/navtag7',
  name: 'navtag7',
  component: () => import('@/views/page/moudel/tag7') //
},
{
  path: '/navtag8',
  name: 'navtag8',
  component: () => import('@/views/page/moudel/tag8') //
},
{
  path: '/test',
  name: 'test',
  component: () => import('@/components/HelloWorld') //
},
{
  path: '/system',
  name: 'system',
  component: () => import('@/views/system/index'),
  children: [{
    path: '/system/syshome',
    component: () => import('@/views/system/home'),
    name: 'syshome'
  },
  {
    path: '/system/userManagement',
    component: () => import('@/views/system/userManagement/userManagement'),
    name: 'userManagement'
  },
  {
    path: '/system/userAudit',
    component: () => import('@/views/system/userManagement/userAudit'),
    name: 'userAudit'
  },
  {
    path: '/system/userDetail',
    component: () => import('@/views/system/userManagement/userDetail'),
    name: 'userDetail'
  },
  {
    path: '/system/myUserInfo',
    component: () => import('@/views/system/userManagement/myUserInfo'), // 个人中心用户资料
    name: 'myUserInfo'
  },
  {
    path: '/system/corpneedinfo',
    component: () => import('@/views/system/corpneedinfoManagement/corpneedinfo.vue'), // 个人中心发布单位需求
    name: 'corpneedinfo'
  },
  {
    path: '/system/corpneedinfoSave',
    component: () => import('@/views/system/corpneedinfoManagement/corpneedinfoSave.vue'),
    name: 'corpneedinfoSave'
  },
  {
    path: '/system/corpneedinfoEdit',
    component: () => import('@/views/system/corpneedinfoManagement/corpneedinfoEdit.vue'),
    name: 'corpneedinfoEdit'
  },
  {
    path: '/system/corpneedinfoAuditor',
    component: () => import('@/views/system/auditorManagement/corpneedinfoAuditor.vue'), //单位需求审核
    name: 'corpneedinfoAuditor'
  },
  {
    path: '/system/unneedinfo',
    component: () => import('@/views/system/unneedinfoManagement/unneedinfo.vue'), // 个人中心发布质押融资
    name: 'unneedinfo'
  },
  {
    path: '/system/unneedinfoEdit',
    component: () => import('@/views/system/unneedinfoManagement/unneedinfoEdit.vue'), // 个人中心发布质押融资
    name: 'unneedinfoEdit'
  },
  {
    path: '/system/unneedinfoSave',
    component: () => import('@/views/system/unneedinfoManagement/unneedinfoSave.vue'), // 个人中心发布质押融资
    name: 'unneedinfoSave'
  },
  {
    path: '/system/unneedinfoAuditor',
    component: () => import('@/views/system/auditorManagement/unneedinfoAuditor.vue'), //质押融资审核
    name: 'unneedinfoAuditor'
  },
  {
    path: '/system/notice',
    component: () => import('@/views/system/noticeManagement/notice.vue'),
    name: 'notice'
  },
  {
    path: '/system/noticeSave',
    component: () => import('@/views/system/noticeManagement/noticeSave.vue'),
    name: 'noticeSave'
  },
  {
    path: '/system/noticeEdit',
    component: () => import('@/views/system/noticeManagement/noticeEdit.vue'),
    name: 'noticeEdit'
  },
  {
    path: '/system/policy',
    component: () => import('@/views/system/policyManagement/policy.vue'),
    name: 'policy'
  },
  {
    path: '/system/policySave',
    component: () => import('@/views/system/policyManagement/policySave.vue'),
    name: 'policySave'
  },
  {
    path: '/system/policyEdit',
    component: () => import('@/views/system/policyManagement/policyEdit.vue'),
    name: 'policyEdit'
  },
	{
	  path: '/system/neednotice',
	  component: () => import('@/views/system/neednotice'),
	  name: 'neednotice'
	},
	{
	  path: '/system/code',
	  component: () => import('@/views/system/codeManage/code.vue'),
	  name: 'code'
	},
	{
	  path: '/system/loginlog',
	  component: () => import('@/views/system/logs/loginlog.vue'),
	  name: 'loginlog'
	},
	{
	  path: '/system/busylog',
	  component: () => import('@/views/system/logs/busylog.vue'),
	  name: 'busylog'
	},
	{
	  path: '/system/errlog',
	  component: () => import('@/views/system/logs/errlog.vue'),
	  name: 'errlog'
	},
	{
	  path: '/system/dataup',
	  component: () => import('@/views/system/dataUp'),
	  name: 'dataup'
	},
	{
	  path: '/system/corpManage',
	  component: () => import('@/views/system/platForm/corp'),
	  name: 'corpManage'
	},
	{
	  path: '/system/corpEdit',
	  component: () => import('@/views/system/platForm/corp/edit'),
	  name: 'corpEdit'
	},
	{
	  path: '/system/corpdetail',
	  component: () => import('@/views/system/platForm/corp/detail'),
	  name: 'corpdetail'
	},
  ]
}
]

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js